<script setup lang="ts">
  import { computed } from 'vue';
  import IconImage from '@/shared/ui/common/IconImage.vue';
  import SimpleLoading from '@/shared/ui/loading/SimpleLoading.vue';

  interface Props {
    text: string;
    icon?: unknown;
    iconAlt?: string;
    outlined?: boolean;
    color?: string;
    disabled?: boolean;
    disabledColor?: string;
    loading?: boolean;
    borderColor?: string;
    type?: 'button' | 'submit' | 'reset';
  }

  const props = defineProps<Props>();

  const buttonClass = computed(() => {
    if (props.color && !props.outlined) {
      return `bg-${props.color} text-white`;
    } else if (props.outlined) {
      return `border-1 border-${props.borderColor ?? '[var(--theme-secondary-ink)]'} text-${props.color ?? '[var(--theme-secondary-ink)]'}`;
    } else {
      return `bg-[var(--theme-secondary)] text-white`;
    }
  });
</script>

<template>
  <button
    class="px-4 py-3 rounded-lg font-medium flex items-center md:text-base text-xs md:gap-3 gap-1 h-10.5 disabled:opacity-50"
    :class="[buttonClass]"
    :style="{ cursor: props.disabled ? 'not-allowed' : 'pointer' }"
    :disabled="props.disabled"
    :type="props.type || 'button'"
  >
    <IconImage
      v-if="icon && !loading"
      :src="icon"
      :alt="iconAlt || ''"
    />
    <span v-if="!loading">{{ text }}</span>
    <SimpleLoading v-else />
  </button>
</template>
